import React from "react";
import { Link } from "react-router-dom";
import "./ProfessionalProjects.scss";

function ProfessionalProjects({ projects }) {
  const isClickable = (index) => {
    return index !== 0;
  };
  return (
    <div className="professional" id="projects">
      <div className="professional-title">
        <h2>PROFESSIONAL PROJECTS</h2>
      </div>
      <div className="professional-projects">
        <ul className="professional-projects_list">
          {projects &&
            projects.map((project, index) => (
              <li key={index}>
                <div className="img">
                  {isClickable(index) ? (
                    <Link to={`/projects/${index}`} key={index}>
                      <img src={project.image} alt={project.title} />
                    </Link>
                  ) : (
                    <img src={project.image} alt={project.title} />
                  )}
{/*/** <Link to={`/projects/${index}`} key={index}>
                      <img src={project.image} alt={project.title} />
                    </Link>
 */}
                </div>
                <h3 className="role">{project.channel}</h3>
                {project.context && <p className="context">{project.context}</p>}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default ProfessionalProjects;
